/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    V1NodeSelectorTerm,
    V1NodeSelectorTermFromJSON,
    V1NodeSelectorTermFromJSONTyped,
    V1NodeSelectorTermToJSON,
} from './V1NodeSelectorTerm';

/**
 * An empty preferred scheduling term matches all objects with implicit weight 0
 * (i.e. it's a no-op). A null preferred scheduling term matches no objects (i.e. is also a no-op).
 * @export
 * @interface V1PreferredSchedulingTerm
 */
export interface V1PreferredSchedulingTerm {
    /**
     * 
     * @type {V1NodeSelectorTerm}
     * @memberof V1PreferredSchedulingTerm
     */
    preference?: V1NodeSelectorTerm;
    /**
     * Weight associated with matching the corresponding nodeSelectorTerm, in the range 1-100.
     * @type {number}
     * @memberof V1PreferredSchedulingTerm
     */
    weight?: number;
}

export function V1PreferredSchedulingTermFromJSON(json: any): V1PreferredSchedulingTerm {
    return V1PreferredSchedulingTermFromJSONTyped(json, false);
}

export function V1PreferredSchedulingTermFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1PreferredSchedulingTerm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'preference': !exists(json, 'preference') ? undefined : V1NodeSelectorTermFromJSON(json['preference']),
        'weight': !exists(json, 'weight') ? undefined : json['weight'],
    };
}

export function V1PreferredSchedulingTermToJSON(value?: V1PreferredSchedulingTerm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'preference': V1NodeSelectorTermToJSON(value.preference),
        'weight': value.weight,
    };
}

